import React, {Component} from 'react';
import styled from 'styled-components';
import media from '../MediaQueries.js';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom'
import xsHeroImage from '../media/xs_hero.jpg';
import smHeroImage from '../media/sm_hero.jpg';
import mdHeroImage from '../media/md_hero.jpg';
import lgHeroImage from '../media/lg_hero.jpg';
import xlHeroImage from '../media/xl_hero.jpg';
import xxlHeroImage from '../media/xxl_hero.jpg';

const Hero = (props) => ( 
	<div>
		<ContainerPadded fluid> </ContainerPadded>
		<ButtonShop size="md"><Link to="/Shop">SHOP CANDLES</Link></ButtonShop>
	</div>

);

export default Hero;


const ContainerPadded = styled(Container)`
	padding: 0!important;
	margin: 0px 0 20px 0;
	height: 272px;
	background-image: url(${xsHeroImage});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: 50% 50%;
	position: relative;


	${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
	${media.md` background-image: url(${mdHeroImage}); height: 468px; `}
	${media.lg` background-image: url(${lgHeroImage}); height: 502px; `}
	${media.xl` background-image: url(${xlHeroImage}); height: 669px; `}
	${media.xxl` background-image: url(${xxlHeroImage}); height:  calc(100vh - 190px); `}
`;

const ButtonShop = styled(Button)`
	display: block!important;
	margin: 0 auto;
	margin-bottom: 20px;
	border: 0px!important;
	background-color: #8B572A!important;
	cursor: pointer;

	  :hover {
	    background-color: #dfbf9f!important;
	  }
	  :focus {
	    box-shadow: none;
	  }
	  :active {
	    background-color: #dfbf9f!important;
	  }

	a {
		color: white;
		font-family: 'Raleway';
		font-size: 18px;

		:hover {
			color: white;
			text-decoration-line: none;
		}


		${media.lg`
			font-size: 20px;
		`}
		${media.xl`
			font-size: 22px;
		`}
	}


`;


// WEBPACK FOOTER //
// ./src/components/Hero.js